import { HOME_PATH, LOGIN_PATH } from "Routes/paths";
import { useNavigate } from "react-router-dom";
import {
  logo,
  passwordshow,
  passwordhide,
  erroricon,
} from "assets/icons/index";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Select, Spin } from "antd";
import { useRegisterFormik } from "Forms/auth/regiterFormik";
import { useDropdown } from "hooks/useDropdown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { getCitiesAction } from "redux/actions/RegiteringListsActions/getCitiesAction";
import { useTranslation } from "react-i18next";

const Register = () => {
  const [country, setCountry] = useState("");
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const formik = useRegisterFormik(country);
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const { userRegisterLoading } = useSelector(
    (state: RootState) => state.userRegisterReducer
  );

  const {
    countriesDropdownEnglish,
    countriesDropdownArabic,
    getCountriesLoading,
    citiesDropdownEnglish,
    citiesDropdownArabic,
    citiesLoading,
    titlesDropdownEnglish,
    titlesDropdownArabic,
    titlesLoading,
  } = useDropdown();

  return (
    <section className="relative">
      <section className="py-[80px] px-[40px] w-full  flex items-center justify-center">
        <section className="w-full flex flex-col items-center justify-center gap-[60px]">
          {/* logo section  */}
          <div className="w-[216px] h-[64px]">
            <img
              onClick={() => navigate(HOME_PATH)}
              className="w-full cursor-pointer"
              src={logo}
              alt="logo"
            />
          </div>

          {/* login form section  */}
          <Spin spinning={userRegisterLoading}>
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="md:w-[424px] p-[25px] bg-white rounded-[20px] flex flex-col gap-[35px]"
            >
              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[20px] lg:text-[24px] text-second_color text-center`}
              >
                {t("Create New Account")}
              </p>

              <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[14px] lg:text-[16px] text-[#707070] text-center`}
              >
                {t("Already have account?")}{" "}
                <span
                  onClick={() => navigate(LOGIN_PATH)}
                  className="ml-[5px] text-first_color underline cursor-pointer"
                >
                  {t("Sign in2")}
                </span>
              </p>

              {/* sign up form  */}
              <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-[16px]"
              >
                {/*************** country menu  ***************/}
                <Spin spinning={getCountriesLoading}>
                  <Select
                    style={{
                      width: "100%",
                      height: "48px",
                      borderColor: "#B6B6B6",
                    }}
                    placeholder={t("Country")}
                    options={
                      i18n.language === "en"
                        ? countriesDropdownEnglish
                        : countriesDropdownArabic
                    }
                    status={formik.errors.country ? "error" : ""}
                    onSelect={(value: any) => {
                      formik.setFieldValue("country", value);
                      dispatch(getCitiesAction(value));
                    }}
                  ></Select>
                </Spin>

                {/*************** city menu  ***************/}
                <Spin spinning={citiesLoading}>
                  <Select
                    style={{
                      width: "100%",
                      height: "48px",
                      borderColor: "#B6B6B6",
                    }}
                    placeholder={t("City")}
                    options={
                      i18n.language === "en"
                        ? citiesDropdownEnglish
                        : citiesDropdownArabic
                    }
                    status={formik.errors.city ? "error" : ""}
                    onSelect={(value: any) => {
                      formik.setFieldValue("city", value);
                    }}
                  ></Select>
                </Spin>

                {/*************** title menu  ***************/}
                <Spin spinning={titlesLoading}>
                  <Select
                    style={{
                      width: "100%",
                      height: "48px",
                      borderColor: "#B6B6B6",
                    }}
                    placeholder={t("Title")}
                    options={
                      i18n.language === "en"
                        ? titlesDropdownEnglish
                        : titlesDropdownArabic
                    }
                    status={formik.errors.title ? "error" : ""}
                    onSelect={(value: any) => {
                      formik.setFieldValue("title", value);
                    }}
                  ></Select>
                </Spin>

                {/*************** full Name section  ***************/}
                <div>
                  <input
                    type="text"
                    placeholder={t("Full Name")}
                    className={`w-full h-[48px] rounded-[10px] font-${
                      i18n.language === "en"
                        ? "Poppins pl-[15px]"
                        : "Almarai pr-[15px]"
                    } font-[400] text-[14px] lg:text-[16px] text-[#707070] border border-[#B6B6B6] focus:outline-none focus:border-first_color focus:border-[1px] focus:shadow-shadow_sec`}
                    name="fullName"
                    onChange={formik.handleChange}
                  />
                  {formik.errors.fullName ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.fullName}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/*************** email section  ***************/}
                <div>
                  <input
                    type="email"
                    placeholder={t("Email")}
                    className={`w-full h-[48px] rounded-[10px] font-${
                      i18n.language === "en"
                        ? "Poppins pl-[15px]"
                        : "Almarai pr-[15px]"
                    } font-[400] text-[14px] lg:text-[16px] text-[#707070] border border-[#B6B6B6] focus:outline-none focus:border-first_color focus:border-[1px] focus:shadow-shadow_sec`}
                    name="email"
                    onChange={formik.handleChange}
                  />{" "}
                  {formik.errors.email ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.email}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/*************** phone number  ***************/}
                <div>
                  <PhoneInput
                    inputStyle={{
                      width: "100%",
                      height: "48px",
                      borderRadius: "10px",
                    }}
                    country={"ae"}
                    countryCodeEditable={false}
                    enableSearch={true}
                    onChange={(phone, x, y, valueseparated) => {
                      // the country code
                      const countryCode = valueseparated.split(" ").shift();
                      formik.setFieldValue("countryCode", countryCode);

                      if (countryCode === "+20") {
                        setCountry("eg");
                      } else if (countryCode === "+971") {
                        setCountry("uae");
                      }
                      const countryCodeLength = countryCode
                        ?.split("")
                        .filter((item: any, idx: number) => idx !== 0)
                        .join("").length;

                      // phone number
                      const phoneNumber = phone.slice(
                        countryCodeLength,
                        phone.length
                      );
                      formik.setFieldValue("phone", phoneNumber);
                    }}
                  />
                  {formik.errors.phone ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.phone}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/*************** password section  ***************/}
                <div>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder={t("Password")}
                      className={`w-full h-[48px] rounded-[10px] font-${
                        i18n.language === "en"
                          ? "Poppins pl-[15px]"
                          : "Almarai pr-[15px]"
                      } font-[400] text-[14px] lg:text-[16px] text-[#707070] border border-[#B6B6B6] focus:outline-none focus:border-first_color focus:border-[1px] focus:shadow-shadow_sec`}
                      name="password"
                      onChange={formik.handleChange}
                    />
                    <div
                      onClick={() => setShowPassword(!showPassword)}
                      className={`absolute ${
                        i18n.language === "en"
                          ? "top-[33%] right-[5%]"
                          : "top-[33%] left-[5%]"
                      }`}
                    >
                      {showPassword ? (
                        <img
                          className="cursor-pointer"
                          src={passwordhide}
                          alt="hide"
                        />
                      ) : (
                        <img
                          className="cursor-pointer"
                          src={passwordshow}
                          alt="show"
                        />
                      )}
                    </div>
                  </div>
                  {formik.errors.password ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.password}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                {/*************** sign Up button  ***************/}

                <button
                  type="submit"
                  className={`mt-[20px] w-full h-[48px] bg-first_color rounded-[10px] text-white font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[14px] lg:text-[16px]`}
                >
                  {t("Sign Up")}
                </button>
              </form>
            </div>
          </Spin>
        </section>
      </section>

      <img
        className="absolute top-0 left-0 w-full h-full -z-10"
        src="../images/loginbg.png"
        alt=""
      />
    </section>
  );
};

export default Register;
